<template>
  <v-icon :class="iconClass"><i class="icon-car-solid"></i></v-icon>
</template>
<script>

export default {
  name: 'TabPlantPowerFlowCar',
  props: {
    iconClass: {
      type: String,
      default: 'grey'
    }
  },
  data: () => ({
  })
}
</script>
<style>
@import '../../../assets/main.css';
</style>
